
export default {
  name: 'Logo'
}
